import React from 'react';
import '../../styles/CircleImageComponent.css';

type ImageComponentProps = {
  src: string;
  alt?: string;
  center?: boolean;
  width?: string;
  height?: string;
};

const CircularImageComponent: React.FC<ImageComponentProps> = ({
  src,
  alt = 'Image',
  center = false,
  width,
  height,
}) => {
  const wrapperStyles: React.CSSProperties = {
    display: center ? 'flex' : 'inline-block',
    justifyContent: center ? 'center' : undefined,
    alignItems: center ? 'center' : undefined,
    width: width || height || '100px', // fallback
    height: height || width || '100px',
  };

  return (
    <div className="circle-image-wrapper" style={wrapperStyles}>
      <img src={src} alt={alt} className="circular-image" />
    </div>
  );
};

export default CircularImageComponent;
